import * as React from 'react';
import { observer } from 'mobx-react';
import style from './HeaderMenu.module.scss';
import { MenuModel } from '../../../models';
import { JoinClassName } from '../../../utils/string';

interface HeaderMenuItemActions {
  onClick: () => any;
}

interface HeaderMenuItemProps extends HeaderMenuItemActions {
  menu: MenuModel;
  active?: boolean;
}

// observer: 번역이 도착하면 menu.textT 가 바뀌므로 다시 그려야 한다.
export const HeaderMenuItem: React.FC<HeaderMenuItemProps> = observer(({
  onClick,
  menu,
  active,
}) => (
  <div
    // 사이드메뉴는 지금 열린 모듈의 화면만 그린다. 다른 모듈의 화면을 열려면
    // 여기를 먼저 눌러야 하므로 모듈에도 짚을 자리가 필요하다.
    data-el-module={menu.id}
    className={JoinClassName.make([style.menu, active ? style.active : false])}
    onClick={() => onClick()}
  >
    <menu.icon />
    <p>{menu.textT}</p>
  </div>
));
